import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { Animals } from '../models/animal.models';
import { environment } from 'src/environments/environment';
import { SortableTable, convertDateToDisplayFormat, convertDateToBackendFormat } from './services-table-helper';

@Injectable({
  providedIn: 'root'
})

export class AnimalsTableService extends SortableTable<Animals> {
  private baseUrl = environment.API_URL;

  animale: Animals[];
  numarAnimale: number;

  constructor(private http: HttpClient) {
    super();
  }

  getAnimalsAPI(obj) {
    return this.http.post(
      `${this.baseUrl}/animals/list/`,
      obj
    ).pipe(map((response: any) => {
      this.animale = response.result;
      this.numarAnimale = response.count;

      this.paginate();
      this._tables$.next(this.animale);
      this._total$.next(this.numarAnimale);

      return response;
    }));
  }

  getAnimalAPI(animalId: number) {
    return this.http
      .get(
        `${this.baseUrl}/animals/${animalId}/`
      ).pipe(map((response: any) => {
        response.datanastere = convertDateToDisplayFormat(response.datanastere);
        response.dataintrareinexploatatie = convertDateToDisplayFormat(response.dataintrareinexploatatie);
        response.data_apr_feno = convertDateToDisplayFormat(response.data_apr_feno);

        return response;
      }));
  }

  getPozaUrl(fileId: number) {
    return this.http
      .post(
        `${this.baseUrl}/files/geturl/`,
        { file_id: fileId }
      ).pipe(map((response: any) => {
        return response;
      }));
  }

  updateAnimal(req_params) {
    return this.http.post(
      `${this.baseUrl}/animals/save/`,
      req_params
    );
  }

  deleteAnimal(animalId: number) {
    return this.http.post(
      `${this.baseUrl}/animals/delete/`,
      { animalid: animalId }
    ).pipe(map(response => {
      return response;
    }, errors => {
      return errors;
    }));
  }

  searchAnimal(matricol: string, sex: number) {
    return this.http.post(
      `${this.baseUrl}/animals/search/`,
      { numarmatricol: matricol, sex }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  generateFisaAnimal(animalid) {
    return this.http
      .post(
        `${this.baseUrl}/animals/fisa-animal/`,
        { animalid },
        {
          responseType: 'blob'
        }
      ).pipe((response: any) => {
        return response;
      });
  }

  downloadAnimalHistoryApi(animalid) {
    return this.http
      .post(
        `${this.baseUrl}/animals/istoric-animal/`,
        { animalid },
        {
          responseType: 'blob'
        }
      ).pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  arboreGenealogicAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/animals/arbore-genealogic/`,
      req_params,
      {
        responseType: 'text'
      }
    );
  }

  arboreGenealogicGenereazaAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/animals/arbore-genealogic/genereaza/`,
      req_params
    );
  }

  downloadXLSArboreGenealogicAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/animals/arbore-genealogic/download-xls/`,
      req_params,
      {
        responseType: 'blob'
      }
    );
  }

  exportXLS(obj) {
    return this.http
      .post(
        `${this.baseUrl}/animals/export/`,
        {
          ...obj
        },
        {
          responseType: 'blob'
        }
      ).pipe(map((response: any) => {
        return response;
      }));
  }

  corespundeStandardAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/animals/corespunde_standard/`,
      req_params
    ).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  solicitareTestADNAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/animals/solicitare-test-adn/`,
      req_params
    );
  }

  solicitareTestADNDownloadAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/animals/solicitare-test-adn/download/`,
      req_params,
      {
        responseType: 'blob'
      }
    );
  }

  FisaBonitareDownloadAPI(req_params) {
    return this.http.post(
      `${this.baseUrl}/animals/fisa-bonitare/download/`,
      req_params,
      {
        responseType: 'blob'
      }
    );
  }


  /**
   * Paginate Method
   */
  private paginate(): void {
    this.totalRecords = this.numarAnimale;
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.numarAnimale) {
      this._state.endIndex = this.numarAnimale;
    }
  }
}
